import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormGroup,
} from "@mui/material";
import ClientOwnerDetails from "../../common/form-components/ClientOwnerDetails";
import { Formik } from "formik";
import AlertRibbon from "../../../common/AlertRibbon";
import { useClientDetails } from "../../context/clientDetailsContext";
import { mainUserForm } from "../../add-client/formSchema";

function ReplaceUserForClient() {
  const {
    replaceMainUser: {
      isReplacing,
      setReplacing,
      replace,
      loading,
      alert,
      setAlert,
    },
  } = useClientDetails();

  return (
    <>
      <Formik
        initialValues={{
          "main-user-first-name": "",
          "main-user-last-name": "",
          email: "",
        }}
        validationSchema={mainUserForm}
        onSubmit={(form) => {
          replace(form);
        }}
        validateOnMount
        initialTouched={{
          "main-user-first-name": true,
          "main-user-last-name": true,
          email: true,
        }}
      >
        {({ handleSubmit, isValid, resetForm }) => (
          <>
            <Dialog
              data-testid="replace-user-modal"
              open={isReplacing}
              fullWidth
              maxWidth="md"
            >
              <DialogTitle>Replace User</DialogTitle>
              <Box component="form" onSubmit={handleSubmit}>
                <DialogContent>
                  {alert && alert.type === "error" && (
                    <AlertRibbon
                      handleClose={() => setAlert(null)}
                      severity={alert.type}
                      message={alert.message}
                      errorCode={alert.errorCode}
                    />
                  )}
                  <FormGroup sx={{ paddingBottom: 2 }}>
                    <ClientOwnerDetails
                      alignmentStyles={{
                        direction: "column",
                      }}
                    />
                  </FormGroup>
                </DialogContent>
                <DialogActions>
                  <Button
                    data-testid="cancel-button"
                    variant="outlined"
                    onClick={() => {
                      setAlert(null);
                      setReplacing(false);
                      resetForm();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    loading={loading}
                    disabled={!isValid}
                    type="submit"
                    variant="contained"
                  >
                    Save
                  </Button>
                </DialogActions>
              </Box>
            </Dialog>
          </>
        )}
      </Formik>
    </>
  );
}

export default ReplaceUserForClient;
